import React from 'react';
import { components } from 'common';
import { lang } from '@umu/ukit-lang';
import './bookDemoContentConfirmDialog.scss';

const { Button } = components;

export interface IProps {
    closeDialog: () => void;
    resetState: () => void;
}

export function BookDemoContentConfirmDialog(props: IProps) {
    const onClose = () => {
        props.closeDialog();
        props.resetState();
    };
    return (
        <div className="cotact-sales-confirm-dialog">
            <div className="title">{lang('提交成功')}</div>
            <div className="body">
                <div
                    dangerouslySetInnerHTML={{
                        // tslint:disable-next-line:max-line-length
                        __html: lang(
                            '您的信息已提交成功，UMU销售团队会很快和您联系，我们期待为您提供优质的产品与服务。',
                        ),
                    }}
                ></div>
            </div>
            <div className="footer">
                <div className="btn-1">
                    <Button className="footer-btn" type="optional" onClick={onClose}>
                        {lang('知道了')}
                    </Button>
                </div>
            </div>
        </div>
    );
}
